import { render, staticRenderFns } from "./regionActivityInformation.vue?vue&type=template&id=f36b289c"
import script from "./regionActivityInformation.vue?vue&type=script&lang=js"
export * from "./regionActivityInformation.vue?vue&type=script&lang=js"
import style0 from "./regionActivityInformation.vue?vue&type=style&index=0&id=f36b289c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports